import { render, staticRenderFns } from "./settingList.vue?vue&type=template&id=46ae9ad8&scoped=true&"
import script from "./settingList.vue?vue&type=script&lang=js&"
export * from "./settingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae9ad8",
  null
  
)

export default component.exports